import React, { SetStateAction, useContext, useEffect } from "react";
import { ChangeEvent, useState } from "react";
import {
    CustomTextField,
    CustomThemeProvider,
} from "../../../Styles/theme/customThemeprovider";
import {
    Box,
    Paper,
    Snackbar,
    Stack,
    TableCell,
    TableRow,
} from "@mui/material";
import { TableBody, TableContainer, TableHead } from "@mui/material";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import BasicPopover from "../../../Components/Popover";
import { StyledTableCell } from "../../../Styles/tabelCellStyled/customTableCell";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { Alert } from "../../../Components/Alert/Alert";
import { IAzoto } from "../../../Interfaces/anexos/anexo1/composicao_adubacao_azoto_nutrientes1_4_7";
import { del, get, post } from "../../../Services/tokenConfig";
import { ICabecalho } from "../../../Interfaces/anexos/anexo1/analise_e_foliar1_1_3";
import { func_print } from "../../../Func_genericas/func_print";
import { IPlanoNutrientes } from "../../../Interfaces/anexos/anexo1/plano_nutrientes1_3";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";

interface ComposicaoQ1Form_prop {
    obj_anexo_cabecalho_selecionado: ICabecalho | undefined;
    set_obj_da_tabela_3_atualizado: React.Dispatch<SetStateAction<IPlanoNutrientes | undefined>>;

}


export const AzotoForm: React.FC<ComposicaoQ1Form_prop> = ({ obj_anexo_cabecalho_selecionado, set_obj_da_tabela_3_atualizado }) => {

    const auth = useContext(AuthContext);
    const location = useLocation();
    const is_historico = location.state?.is_historico ?? false;


    const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);

    const [createTable, setCreateTable] = useState(false);
    const [message, setMessage] = useState("");
    const [error_n, set_error_n] = useState<boolean>(false);
    const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
    const [openSnackError, setOpenSnackError] = React.useState(false);
    const [obj_anexo, set_obj_anexo] = useState<IAzoto>();
    const [obj_anexo_lista, set_obj_anexo_lista] = useState<IAzoto[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const [existe_cabecalho, set_existe_cabecalho] = useState(false)


    const [flag_editado, set_flag_editado] = React.useState(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

    const handleCloseDialog = () => {
        set_obj_anexo(undefined)
        set_error_n(false)
        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };

    const onInputChange = (event: any) => {
        const { name, value, type, checked } = event.target;
        let aux_obj_anexo: any = obj_anexo === undefined ? {} : obj_anexo
        set_flag_editado(true)

        if (type === "checkbox") {
            aux_obj_anexo[name] = aux_obj_anexo[name] === undefined ? true : !aux_obj_anexo[name]
            set_obj_anexo(aux_obj_anexo);

        } else {
            if (name === 'n') {
                if (/[a-zA-Z]/.test(value)) {
                    set_error_n(true)
                } else {
                    set_error_n(false)
                }
                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: format_strings_to_numbers(value, false),
                }));
            } else {

                set_obj_anexo((old: any) => ({
                    ...old,
                    [name]: value,
                }));
            }

        }


    };

    const handleCloseSnack = () => {
        setOpenSnackSuccess(false);
        setOpenSnackError(false);
    };

    const handle_criar_anexo = async () => {
        if (error_n) {
            setMessage("Erro ao efetuar a sua operação!");
            setOpenSnackError(true);

        } else {

            try {
                setIsLoading(true);

                let data = await post(auth.token.cookie_token, "new_reg_anexo_um_seis", {
                    payload: {

                        id_azoto: 0,
                        n: obj_anexo?.n === undefined ? '' : obj_anexo?.n,
                        id_anexo_um_cabecalho: obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho,
                        last_update: new Date().toISOString(),
                        create_date: new Date().toISOString(),
                        uuid: ""
                    }
                })
                if (data.status === 200) {
                    setMessage("Operação efetuada com sucesso!");
                    setOpenSnackSuccess(true);
                    set_obj_anexo_lista([data.data.result[0]])
                    set_obj_da_tabela_3_atualizado(data.data.result[1])
                    set_obj_anexo(undefined)
                    setCreateTable(false)
                    set_flag_editado(false)

                } else {
                    setMessage("Erro ao efetuar a sua operação!");
                    setOpenSnackError(true);
                }
                setIsLoading(false);

            } catch (error) {
                func_print('handle_criar_anexo', error, true)
                setIsLoading(false);

                setMessage("Erro ao efetuar a sua operação!");
                setOpenSnackError(true);
            }
        }
    }
    const handle_update_anexo = async () => {
        try {
            setIsLoading(true);
            let res = await post(auth.token.cookie_token, "update_reg_anexo_um_seis", { payload: obj_anexo });

            if (res.status === 200) {
                let lista_aux: any = obj_anexo_lista?.map((el) => {
                    if (el.id_azoto !== obj_anexo?.id_azoto) {
                        return el
                    } else {
                        return res.data.result[0]
                    }
                })
                set_flag_editado(false)

                set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
                set_obj_anexo(undefined);
                set_obj_da_tabela_3_atualizado(res.data.result[1])

                setMessage("Gravado com sucesso!");
                setOpenSnackSuccess(true);
            } else {
                setMessage("Erro ao gravar!");

                setOpenSnackError(true);
            }

            setIsLoading(false);
        } catch (error) {
            func_print("handle_update_anexo", error, true);
            setMessage("Erro ao gravar!");

            setOpenSnackError(true);
            setIsLoading(false);
        }
    };
    const handle_delete_anexo = async () => {
        try {
            setIsLoading(true);

            let res = await del(auth.token.cookie_token,
                `delete__reg_anexo_um_seis/${obj_anexo?.id_azoto}`
            );
            if (res.status === 200) {
                let lista_aux: any = obj_anexo_lista?.filter((el) => {
                    if (el.id_azoto !== obj_anexo?.id_azoto) {
                        return el
                    }
                })
                set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
                set_obj_anexo(undefined)
                if (lista_aux === undefined || lista_aux.length === 0) {
                    setCreateTable(true)
                }
                set_obj_da_tabela_3_atualizado(res.data.result)

                setMessage("Registo eliminado com sucesso!");
                set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
                setOpenSnackSuccess(true);

            } else {
                setMessage("Erro ao eliminar o registo!");
                setOpenSnackError(true);
            }
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_anexo", error, true);
            setIsLoading(false);
            setMessage("Erro ao eliminar o registo!");
            setOpenSnackError(true);
        }
    };

    const get_info = async () => {
        try {
            let res = await get(auth.token.cookie_token,
                `/get_reg_anexo_um_seis_cabecalho/${obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho}`
            );

            if (res.status === 200) {
                if (res.data.result.length !== 0) {
                    set_obj_anexo_lista(res.data.result);
                } else {
                    setCreateTable(true)
                }
            } else {
                setMessage("Erro a carregar informação!");
                setOpenSnackError(true);
            }

            setIsLoading(false);
        } catch (error) {
            func_print("get_info", error, true);
            setMessage("Erro!");

            setOpenSnackError(true);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        (async () => {
            if (obj_anexo_cabecalho_selecionado !== undefined) {

                await get_info();
                set_existe_cabecalho(true)

            } else {
                set_existe_cabecalho(false)
                set_obj_anexo_lista([]);


            }
        })();
    }, [obj_anexo_cabecalho_selecionado]);

    return (
        <CustomThemeProvider>
            <TableContainer
                component={Paper}
                variant="outlined"
                sx={{
                    height: "auto",
                    width: "auto",
                    margin: 2,
                    padding: 2,
                }}
            >
                <Snackbar
                    open={openSnackSuccess}
                    autoHideDuration={2000}
                    onClose={handleCloseSnack}
                >
                    <Alert
                        onClose={handleCloseSnack}
                        severity="success"
                        sx={{ width: "100%" }}
                    >
                        {message}
                    </Alert>
                </Snackbar>
                <Snackbar
                    open={openSnackError}
                    autoHideDuration={2000}
                    onClose={handleCloseSnack}
                >
                    <Alert
                        onClose={handleCloseSnack}
                        severity="error"
                        sx={{ width: "100%" }}
                    >
                        {message}

                    </Alert>
                </Snackbar>
                <table>
                    <TableHead>
                        <TableRow>
                            <TableCell
                                colSpan={2}
                                sx={{
                                    fontWeight: 600,
                                    textAlign: "left",
                                    fontFamily: "candara",
                                    fontSize: 16,
                                    width: "60%",
                                }}
                            >
                                1.6 - Azoto proveniente dos resíduos das culturas precedentes
                                <BasicPopover
                                    text={
                                        "O beneficiário deve preencher este campo com base nos valores do Quadro 2 do Anexo VI da portaria n.º 259/2012, de 28 de agosto Ou com base no Quadro 21 do Manual de Fertilização das Culturas do INIAV (2022)."
                                    }
                                />
                            </TableCell>

                            {
                                obj_anexo_lista.length === 0 || obj_anexo_lista === undefined ?
                                    existe_cabecalho === false ? <></> :
                                        createTable === false ?
                                            <TableCell>
                                                <Stack direction="row" justifyContent="end">
                                                    {is_historico === true ? <></> :

                                                        <BarraDeFerramentas
                                                            mostrarBotaoNovo
                                                            textoBotaoNovo="Registar"
                                                            aoClicarNovo={() => setCreateTable(true)}
                                                        />}
                                                </Stack>
                                            </TableCell>
                                            :
                                            <TableCell>
                                                {is_historico === true ? <></> :

                                                    <ButtonCadernos
                                                        mostrarBotaoGravar
                                                        aoClicarGravar={() => { handle_criar_anexo() }}
                                                    />}
                                            </TableCell>

                                    : <></>
                            }
                        </TableRow>

                    </TableHead>


                    {createTable && (
                        <TableBody>
                            <TableRow>
                                <TableCell>
                                    <Stack direction="row" justifyContent="start">
                                        N (kg/ha):
                                        <Box margin={-1} padding={0}>
                                            <BasicPopover
                                                text={
                                                    "Preencher de acordo com Portaria n.º259/2012_Programa de Ação - Anexo VI - Quadro 2.  \n\nPrecedente cultural ........................ Azoto a adicionar (+) ou retirar (-) à recomendação  \n Beterraba (folhas recolhidas) ……………………………………........... 0  \n Beterraba (folhas incorporadas) ............................................... -20  \nCereais (palha recolhida) ........................................................... 0 \n Cereais (palha incorporada) ...................................................... 20 \n Couve-brócolo ......................................................................... -30   \n  Couve-de-bruxelas ................................................................... -30   \n Couve-flor ............................................................................... -30  \nPrado temporário (2 ou mais anos) ........................................... -20 \n Prado luzerna .......................................................................... -40                          \n  Cultura intercalar - gramíneas ..................................... -1,5 kg de N/t matéria verde incorporada                            \nCultura intercalar - leguminosas .................................. -2,5 kg de N/t matéria verde incorporada"
                                                }
                                            />
                                        </Box>
                                    </Stack>
                                </TableCell>
                                <StyledTableCell>
                                    <CustomTextField
                                        name="n"
                                        value={obj_anexo?.n === undefined ? '' : obj_anexo?.n.toString().replace('.', ',')}
                                        onChange={onInputChange}
                                        error={error_n}
                                        helperText={error_n ? "Apenas números são aceites" : ""}
                                    />
                                </StyledTableCell>
                            </TableRow>
                        </TableBody>
                    )}

                    {obj_anexo_lista?.map((tab, key) => {
                        if (tab.id_azoto === obj_anexo?.id_azoto) {
                            return (
                                <TableBody key={key}>
                                    <TableRow>
                                        <TableCell colSpan={2}>
                                            <Stack direction="row" justifyContent="end">
                                                <ButtonCadernos
                                                    mostrarBotaoGravar
                                                    aoClicarGravar={() => { handle_update_anexo() }}
                                                    mostrarBotaoCancelar
                                                    aoClicarCancelar={() => {
                                                        if (flag_editado) {
                                                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                                        } else {
                                                            set_obj_anexo(undefined)
                                                        }
                                                    }}
                                                />
                                            </Stack>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <Stack direction="row" justifyContent="start">
                                                N (kg/ha):
                                                <Box margin={-1} padding={0}>
                                                    <BasicPopover
                                                        text={
                                                            "Preencher de acordo com Portaria n.º259/2012_Programa de Ação - Anexo VI - Quadro 2.  \n\nPrecedente cultural ........................ Azoto a adicionar (+) ou retirar (-) à recomendação  \n Beterraba (folhas recolhidas) ……………………………………........... 0  \n Beterraba (folhas incorporadas) ............................................... -20  \nCereais (palha recolhida) ........................................................... 0 \n Cereais (palha incorporada) ...................................................... 20 \n Couve-brócolo ......................................................................... -30   \n  Couve-de-bruxelas ................................................................... -30   \n Couve-flor ............................................................................... -30  \nPrado temporário (2 ou mais anos) ........................................... -20 \n Prado luzerna .......................................................................... -40                          \n  Cultura intercalar - gramíneas ..................................... -1,5 kg de N/t matéria verde incorporada                            \nCultura intercalar - leguminosas .................................. -2,5 kg de N/t matéria verde incorporada"
                                                        }
                                                    />
                                                </Box>
                                            </Stack>
                                        </TableCell>
                                        <StyledTableCell>
                                            <CustomTextField
                                                name="n"
                                                value={obj_anexo?.n === undefined ? '' : obj_anexo?.n.toString().replace('.', ',')}
                                                onChange={onInputChange}
                                                error={error_n}
                                                helperText={error_n ? "Apenas números são aceites" : ""}
                                            />
                                        </StyledTableCell>
                                    </TableRow>
                                </TableBody>
                            );
                        } else {
                            return (
                                <TableBody key={key}>
                                    <TableRow>
                                        <TableCell colSpan={3}>
                                            <Stack direction="row" justifyContent="end">
                                                {is_historico === true ? <></> :

                                                    <ButtonCadernos
                                                        mostrarBotaoEditar
                                                        aoClicarEditar={() => set_obj_anexo(tab)}
                                                        mostrarBotaoApagar
                                                        aoClicarApagar={() => {
                                                            set_obj_anexo(tab)
                                                            set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                                                        }}
                                                    />}
                                            </Stack>
                                        </TableCell>

                                    </TableRow>

                                    <TableRow>
                                        <TableCell>
                                            <Stack direction="row" justifyContent="start">
                                                N (kg/ha):
                                                <Box margin={-1} padding={0}>
                                                    <BasicPopover
                                                        text={
                                                            "Preencher de acordo com Portaria n.º259/2012_Programa de Ação - Anexo VI - Quadro 2.  \n\nPrecedente cultural ........................ Azoto a adicionar (+) ou retirar (-) à recomendação  \n Beterraba (folhas recolhidas) ……………………………………........... 0  \n Beterraba (folhas incorporadas) ............................................... -20  \nCereais (palha recolhida) ........................................................... 0 \n Cereais (palha incorporada) ...................................................... 20 \n Couve-brócolo ......................................................................... -30   \n  Couve-de-bruxelas ................................................................... -30   \n Couve-flor ............................................................................... -30  \nPrado temporário (2 ou mais anos) ........................................... -20 \n Prado luzerna .......................................................................... -40                          \n  Cultura intercalar - gramíneas ..................................... -1,5 kg de N/t matéria verde incorporada                            \nCultura intercalar - leguminosas .................................. -2,5 kg de N/t matéria verde incorporada"
                                                        }
                                                    />
                                                </Box>
                                            </Stack>
                                        </TableCell>
                                        <StyledTableCell>{tab.n.toString().replace('.', ',')}</StyledTableCell>
                                    </TableRow>

                                </TableBody>
                            );
                        }
                    })}

                </table>
                <ConfirmDialog
                    open={open_dialog_tem_a_certeza_que_quer_eliminar}
                    onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
                    onConfirm={handle_delete_anexo}
                    message="Deseja eliminar o registo?"
                />
                <ConfirmDialog
                    open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                    onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                    onConfirm={() => handleCloseDialog()}
                    message={mensagem_tem_a_certeza_de_apagar_alteracoes}
                />
            </TableContainer>
        </CustomThemeProvider >
    );
};